<template>
  <div>
    <el-input  :value="words"
               @input="e => words = inputVaildate(e)"  placeholder="请输入内容">
    </el-input>
  </div>
</template>

<script>
export default {
  methods: {

inputVaildate(value, number = 24) {
  value = value.replace(/[`~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/g, '').replace(/\s/g, "");
  if (value.length >= number) {
    this.$message({
      type: "warning",
      message: `输入内容不能超过${number}个字符`
    });
  }
  return value;
}
  }
};
</script>



// WEBPACK FOOTER //
// src/components/reportTools/test.vue